import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const usePagination = (defaultPage = 1, defaultLimit = 10) => {
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(defaultPage);
  const [limit, setLimit] = useState(defaultLimit);

  useEffect(() => {
    const pageParam = parseInt(searchParams.get("page")) || defaultPage;
    const limitParam = parseInt(searchParams.get("limit")) || defaultLimit;

    setPage(pageParam);
    setLimit(limitParam);
  }, [searchParams, defaultPage, defaultLimit]);

  return { page, limit };
};

export default usePagination;
